// extracted by extract-css-chunks-webpack-plugin
module.exports = {"xxl":"1919px","xxxl":"2399px"};